import { get } from 'lodash';

import {
	TRANSACTION_DETAIL_REQUESTING,
	TRANSACTION_DETAIL_SUCCESS,
	TRANSACTION_DETAIL_ERROR,
	REFUND_TRANSACTION_REQUESTING,
	REFUND_TRANSACTION_SUCCESS,
	REFUND_TRANSACTION_ERROR,
	CASHBACK_DETAIL_REQUESTING,
	CASHBACK_DETAIL_SUCCESS,
	CASHBACK_DETAIL_ERROR,
} from './types';

export const initialState = {
	loading: false,
	detailData: {},
	cashbackDetail: [],
	error: undefined,
};

function transactionDetail(state = initialState, action) {
	switch (action.type) {
		case TRANSACTION_DETAIL_REQUESTING:
			return {
				...state,
				loading: true,
				detailData: {},
			};
		case TRANSACTION_DETAIL_SUCCESS:
			return {
				...state,
				loading: false,
				detailData: action.data,
				error: undefined,
			};
		case TRANSACTION_DETAIL_ERROR:
		case REFUND_TRANSACTION_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case CASHBACK_DETAIL_REQUESTING:
			return {
				...state,
				cashbackDetail: [],
			};
		case CASHBACK_DETAIL_SUCCESS:
			return {
				...state,
				cashbackDetail: get(action, 'data.customerCashBacks', []),
				error: undefined,
			};
		case CASHBACK_DETAIL_ERROR:
			return {
				...state,
				error: action.error,
			};
		case REFUND_TRANSACTION_REQUESTING:
			return { ...state, loading: true };
		case REFUND_TRANSACTION_SUCCESS:
			return {
				...state,
				loading: false,
				error: undefined,
			};
		default:
			return state;
	}
}

export default transactionDetail;
